export const categories = [
  {
    type: "urban",
    name: "都市剧",
    desc: "聚焦都市生活、职场奋斗与情感际遇，展现当代城市人群的喜怒哀乐。",
    icon: "ri-building-2-line",
  },
  {
    type: "costume",
    name: "古装剧",
    desc: "以历史或架空古代为背景，呈现宫廷权谋、江湖侠义与古典美学。",
    icon: "ri-ancient-gate-line",
  },
  {
    type: "suspense",
    name: "悬疑剧",
    desc: "层层反转的推理与罪案题材，烧脑剧情带你抽丝剥茧寻找真相。",
    icon: "ri-fingerprint-line",
  },
  {
    type: "modern",
    name: "现代剧",
    desc: "贴近当下现实生活的题材，涵盖都市、职场、家庭与青春成长。",
    icon: "ri-smartphone-line",
  },
  {
    type: "romance",
    name: "爱情剧",
    desc: "甜宠、虐恋与双向奔赴，讲述让人心动的爱情故事与情感纠葛。",
    icon: "ri-heart-3-line",
  },
  {
    type: "family",
    name: "家庭剧",
    desc: "围绕家庭关系与代际情感的温情叙事，烟火气中体味人间冷暖。",
    icon: "ri-home-heart-line",
  },
];

export const collections = [
  {
    id: "hot",
    name: "热播榜",
    desc: "近期全网热度最高的剧集，根据播放讨论度实时排序。",
  },
  {
    id: "top-rated",
    name: "高分好评",
    desc: "口碑出众、评分领先的优质剧集，值得一追再追。",
  },
  {
    id: "new-release",
    name: "新剧上线",
    desc: "2024—2025 年最新上线的剧集，追新不落伍。",
  },
  {
    id: "completed",
    name: "已完结精选",
    desc: "已完结、可一次追完的口碑好剧，告别追更焦虑。",
  },
];